import {
  CreditScoreIcon,
  OverViewIcon,
  PortfolioIcon,
  ReputationIcon,
  StrategyIcon,
  TokenHealthIcon,
  TransactionMonitoring,
  UserAnalysis,
  UserMonitoring,
} from "src/components/Icon";

export const navLinkConfig = [
  { name: "Lending Pool", link: "/" },
  { name: "Reserve Currency", link: "https://tradao.finance/", isToggle: true, isExternal: true },
  { name: "Knight NFT", link: "https://nft.trava.finance/", isToggle: true, isExternal: true },
  { name: "Staking", link: "/staking/" },
  { name: "Governance", link: "/governance/" },
  { name: "BRicher", link: "/bricher/" },
  { name: "Bridge", link: "/bridge/" },
  { name: "Analytics", link: "/scoring/", main: true },
];

export const scoringTabConfig = [
  { name: "Credit Score", link: "/credit-score", icon: CreditScoreIcon },
  { name: "Credit Score Strategy", link: "/credit-score-strategy", icon: StrategyIcon },
  { name: "Tokens Health", link: "/tokens-health", icon: TokenHealthIcon },
  { name: "Reputation", link: "/reputation", icon: ReputationIcon },
  { name: "Your Portfolio", link: "/portfolio", icon: PortfolioIcon },
];

export const analysisTabConfig = [
  { name: "Overview", link: "/overview-analysis", icon: OverViewIcon, isAdmin: false },
  { name: "User Analysis", link: "/user-analysis", icon: UserAnalysis, isAdmin: false },
  { name: "User Monitoring", link: "/user-monitoring", icon: UserMonitoring, isAdmin: false },
  { name: "Transaction Monitoring", link: "/transaction-monitoring", icon: TransactionMonitoring, isAdmin: true },
  { name: "Pool Monitoring", link: "/pool-monitoring", icon: TransactionMonitoring, isAdmin: false },
];
